// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"b8150724","453":"6fa2246d","667":"37792ee1"}[chunkId] + ".chunk.js");